/**
 * Frontend copy of the built-in layout (backend: models/reportcard.layout.js).
 * Used for old published snapshots that were saved before layouts existed.
 */
export const DEFAULT_LAYOUT = {
  version: 1,
  settings: { title: "", font_size: 11, show_logo: true, show_school_address: true },
  blocks: [
    { id: "header", type: "HEADER", visible: true },
    { id: "student", type: "STUDENT_INFO", visible: true, title: "",
      fields: ["student_name", "class", "father_name", "sr_no", "mother_name", "roll_no", "date_of_birth"] },
    { id: "scholastic", type: "SCHOLASTIC", visible: true, title: "Scholastic Area",
      show_theory_practical: true, show_grand_total: true, show_percentage: true, show_result: true },
    { id: "co_scholastic", type: "CO_SCHOLASTIC", visible: true, title: "Co-Scholastic Area [on a 5 point (A–E) grading scale]" },
    { id: "footer", type: "FOOTER", visible: true, title: "" },
    { id: "signatures", type: "SIGNATURES", visible: true, labels: ["Date", "Class Teacher's Signature", "Principal's Signature"] },
    { id: "legend", type: "GRADE_LEGEND", visible: true,
      title: "Instruction: Grades are awarded on an 8-point & 5-point grading scale",
      show_scholastic: true, show_co_scholastic: true },
  ],
};

export const BLOCK_INFO = {
  HEADER: { label: "School Header", icon: "fa-school", core: true },
  STUDENT_INFO: { label: "Student Details", icon: "fa-id-card", core: true },
  SCHOLASTIC: { label: "Marks Table (Scholastic)", icon: "fa-table", core: true },
  CO_SCHOLASTIC: { label: "Co-Scholastic Grades", icon: "fa-table-list", core: true },
  FOOTER: { label: "Footer Fields (Attendance, Remarks…)", icon: "fa-list", core: true },
  SIGNATURES: { label: "Signatures", icon: "fa-signature" },
  GRADE_LEGEND: { label: "Grade Legend / Instruction", icon: "fa-circle-info", core: true },
  TEXT: { label: "Custom Text", icon: "fa-font" },
  SPACER: { label: "Blank Space", icon: "fa-arrows-up-down" },
};

export const STUDENT_FIELDS = [
  { key: "student_name", label: "Student's Name" },
  { key: "class", label: "Class" },
  { key: "father_name", label: "Father's Name" },
  { key: "sr_no", label: "S.R. No." },
  { key: "mother_name", label: "Mother's Name" },
  { key: "roll_no", label: "Roll No." },
  { key: "date_of_birth", label: "Date of Birth" },
];

/** Sample report used by the layout designer preview */
export const SAMPLE_REPORT = (() => {
  const cell = (tm, to, pm, po, g) => ({
    theory: { max: tm, obt: to }, practical: { max: pm, obt: po }, total: { max: tm + pm, obt: to + po },
    has_theory: true, has_practical: true, grade: g,
  });
  const g = (p) => (p > 90 ? "A1" : p > 80 ? "A2" : p > 70 ? "B1" : p > 60 ? "B2" : "C1");
  const subs = [["English", 80, 20, 68, 17], ["Economics", 80, 20, 70, 18], ["Political Science", 80, 20, 75, 19], ["IP/PE", 70, 30, 60, 26], ["Painting", 30, 70, 25, 65]];
  return {
    report_type: "ANNUAL", issue_date: new Date().toISOString().slice(0, 10), result_status: "PASS",
    student: { student_name: "Sample Student", father_name: "Father Name", mother_name: "Mother Name", class_name: "XI", section_name: "A",
      sr_no: "SR101", roll_no: "1", date_of_birth: "01-05-2010", session_year: "2026-2027" },
    columns: [
      { key: "G1", name: "Term 1", exam_titles: [{ name: "Half Yearly" }] },
      { key: "G2", name: "Term 2", exam_titles: [{ name: "Annual" }] },
    ],
    scholastic: {
      subjects: subs.map(([n, tm, pm, to, po]) => ({
        name: n,
        columns: { G1: cell(tm, to, pm, po, g(to + po)), G2: cell(tm, to - 5, pm, po, g(to + po - 5)) },
        grand_total: { total: { obt: 2 * (to + po) - 5, max: 200 }, grade: g(to + po - 2.5) },
      })),
      totals: { columns: { G1: { obt: 433, max: 500, grade: "A2" }, G2: { obt: 408, max: 500, grade: "A2" } },
        grand_total: { obt: 841, max: 1000, percentage: 84.1, grade: "A2" } },
    },
    co_scholastic: {
      columns: [{ key: "G1", name: "Term 1" }, { key: "G2", name: "Term 2" }],
      subjects: [
        { id: 1, name: "Physical & Health Education", grades: { G1: "A", G2: "A" } },
        { id: 2, name: "Work Experience", grades: { G1: "B", G2: "A" } },
      ],
    },
    footer: [
      { field_key: "ATTENDANCE", title: "Attendance", value: "180 / 200" },
      { field_key: "PROMOTED_CLASS", title: "Promoted to Class", value: "XII" },
      { field_key: "TEACHER_REMARK", title: "Class Teacher's Remarks", value: "Hard working and sincere.", input_type: "TEXTAREA" },
    ],
    grade_legend: {
      scholastic: [["A1", 90.01, 100], ["A2", 80.01, 90], ["B1", 70.01, 80], ["B2", 60.01, 70], ["C1", 50.01, 60], ["C2", 40.01, 50], ["D", 32.01, 40], ["E", 0, 32]]
        .map(([grade, from, to]) => ({ grade, from, to })),
      co_scholastic: [["A", 80.01, 100], ["B", 60.01, 80], ["C", 40.01, 60], ["D", 32.01, 40], ["E", 0, 32]].map(([grade, from, to]) => ({ grade, from, to })),
    },
  };
})();
